import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/css/homewhychooseus.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPeopleGroup, faStore, faComment, faWrench, faLeaf, faClock } from '@fortawesome/free-solid-svg-icons'

const features = [
  {
    icon: faPeopleGroup,
    title: "Experienced Team",
    description: "18+ years in AC sales & service with certified professionals who understand every aspect of climate control systems.",
  },
  {
    icon: faStore,
    title: "Multi-Brand Dealer",
    description: "Authorized dealer for premium brands including Mitsubishi, Daikin, Blue Star, and more to meet diverse customer needs.",
  },
  {
    icon: faComment,
    title: "Customer Satisfaction",
    description: "Prompt pre & post-sales support with a dedicated service team committed to resolving your concerns quickly.",
  },
  {
    icon: faWrench,
    title: "Professional Installation",
    description: "Safety-focused & high-quality setup by trained technicians ensuring optimal performance and longevity of your systems.",
  },
  {
    icon: faLeaf,
    title: "Energy-Efficient",
    description: "Eco-friendly and cost-effective air conditioning solutions that reduce your carbon footprint and monthly utility bills.",
  },
  {
    icon: faClock,
    title: "24/7 Support",
    description: "Round-the-clock emergency service and maintenance to ensure your comfort is never compromised at any hour.",
  },
];

const HomeWhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="why-choose-section">
      <Container>
        {/* Header Section with Animated Element */}
        <div className="section-header">
          <h2 className="section-title">Why Choose BCAS?</h2>
         
          <p className="section-description mt-2">
            We believe that customer satisfaction leads to long-term success.
            Our expertise, partnerships, and professional approach set us apart in the industry.
          </p>
        </div>
        
        {/* Feature Cards */}
        <Row className="g-4">
          {features.map((feature, index) => (
            <Col key={index} md={6} lg={4}>
              <div className="feature-card">
                <div className="feature-icon-wrapper " >
                  <FontAwesomeIcon icon={feature.icon} className="feature-icons mb-2" />
                  {/* Optional Background for Icon */}
                  <div className="icon-background"></div>
                </div>
                
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                
                {/* Decorative Elements */}
                <div className="card-decoration"></div>
              </div>
            </Col>
          ))}
        </Row>
        
        {/* Emphasis Block */}
        <div className="emphasis-block">
          <div className="emphasis-content">
            <i className="bi bi-shield-check"></i>
            <h4>Trusted by Over 5,000+ Customers</h4>
            <p>Experience the quality and reliability that thousands of satisfied customers already enjoy.</p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HomeWhyChooseUs;
